import { FetchRequestFx } from "../effects/FetchRequestFx";
import { createForm } from "efform";
import { forward } from "effector/effector.umd";
import OnFetchDataEvt from "../events/OnFetchDataEvt";
import { SubmitDataFx } from "../effects/SubmitDataFx";
import FTLSmartDetailGate from "../gates/FTLSmartDetailGate";
import { createStore } from "effector";
export default function FTLSmartDetailDomainStore(props) {
    const ftlSmartDetailDomainStore = createForm(props.schema);
    const formMeta = createStore({
        showErrors: false,
        isLoad: false
    });
    const fetchRequestFX = FetchRequestFx(props.repository);
    const onFetchEvt = OnFetchDataEvt();
    const submitDataFx = SubmitDataFx(props.repository);
    const gate = FTLSmartDetailGate();
    forward({
        from: gate.open,
        to: onFetchEvt
    });
    forward({
        from: onFetchEvt,
        to: fetchRequestFX
    });
    forward({
        from: fetchRequestFX.doneData,
        to: ftlSmartDetailDomainStore.fill
    });
    forward({
        from: ftlSmartDetailDomainStore.submitted,
        to: submitDataFx
    });
    ftlSmartDetailDomainStore.values.watch(() => ftlSmartDetailDomainStore.validate());
    gate.close.watch(() => { ftlSmartDetailDomainStore.fill({}); });
    forward({
        from: submitDataFx.doneData,
        to: ftlSmartDetailDomainStore.fill
    });
    formMeta.on(ftlSmartDetailDomainStore.submitted, () => {
        return { showErrors: true, isLoad: true };
    });
    formMeta.on(submitDataFx.doneData, () => {
        return { showErrors: true, isLoad: false };
    });
    formMeta.on(submitDataFx.failData, () => {
        return { showErrors: true, isLoad: false };
    });
    formMeta.on(onFetchEvt, () => {
        return { showErrors: true, isLoad: true };
    });
    formMeta.on(fetchRequestFX.doneData, () => {
        return { showErrors: true, isLoad: false };
    });
    formMeta.on(fetchRequestFX.failData, () => {
        return { showErrors: true, isLoad: false };
    });
    formMeta.on(gate.close, () => {
        return {
            showErrors: false, isLoad: false
        };
    });
    formMeta.watch((state) => console.log('formMeta', state));
    ftlSmartDetailDomainStore.values.watch((state) => console.log('ftlSmartDetailDomainStore.values', state));
    ftlSmartDetailDomainStore.errors.watch((state) => console.log('ftlSmartDetailDomainStore.errors', state));
    return {
        store: ftlSmartDetailDomainStore,
        gate: gate,
        onFetchEvt: onFetchEvt,
        meta: formMeta
    };
}
//# sourceMappingURL=FTLSmartDetailDomainStore.js.map